import React, { useEffect, useRef, useState } from 'react';
import './Standouts.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import LiveTickerBar from '../../components/live-ticker-bar/liveTickerBar';
import { Col, Row, Card } from 'react-bootstrap';
import DropdownPicker from '../../components/pickers/dropdownPicker';
import DataTableComponent from '../../components/dataTables/dataTable';
import Spinner from '../../components/spinner';
import { DashboardServiceApi, QueryServiceApi, Configuration } from '../../services/smartscreen';
import { IndexServiceApi } from '../../services/actionHub/api';
import { Configuration as IndexServiceApiConfiguration } from '../../services/actionHub/configuration';
import { useSelector } from 'react-redux';
import lodash from 'lodash';
import { APIControl } from '../../helpers/APIControl';
import Categories from './Categories';
import { useTranslation } from 'react-i18next';
import { Toast } from 'primereact/toast';

//#region Helper Functions
const transformColumns = (items, dataId) => {
  const taListItem = [11, 12, 13, 14];

  // Get the actual number of dynamic columns to be displayed
  const dynamicColumnsCount = items.filter(item =>
    item.binding !== 'code1' &&
    !(item.binding === 'indicators' && (dataId === 11 || dataId === 12)) &&
    item.binding !== 'code'
  ).length;

  // Check if indicators column exists in the visible columns
  const hasIndicatorsColumn = items.some(item =>
    item.binding === 'indicators' &&
    !(dataId === 11 || dataId === 12)
  );

  // Determine if we should use equal widths
  const useEqualWidths = dynamicColumnsCount <= 3;

  // Calculate the static column width
  const staticColumnWidth = useEqualWidths ? '25%' : (dynamicColumnsCount <= 2 ? '25%' : '10%');

  const staticColumns = [
    {
      id: 1,
      field: 'multiitemHeader',
      displayName: 'Hisse',
      header: 'Hisse Kodu',
      isVisible: true,
      format: 'f-c-t',
      align: 'left',
      sortable: true,
      width: staticColumnWidth,
      headerAlign: 'left',
      paddingLeft: '10px',
      headerPaddingLeft: '20px',
    },
  ];

  const dynamicColumns = items
    .filter(item => item.binding !== 'code1') // Exclude 'code1' from dynamic columns
    .map((item, index) => {
      const totalColumns = items.length + staticColumns.length;
      const isDataId10 = dataId === 10;
      const isIndicator = item.binding === 'indicators';
      const isCode = item.binding === 'code';
      const isConsResearch = item.binding === 'consResearch';

      // Calculate width based on number of columns
      let adjustedWidth;

      // If we have 3 or fewer dynamic columns and indicators column exists
      if (useEqualWidths && hasIndicatorsColumn) {
        if (isIndicator) {
          // Give indicators column more space (40% of the available 75%)
          adjustedWidth = '40%';
        } else {
          // Distribute the remaining space (35%) among other columns
          const otherColumnsCount = dynamicColumnsCount - 1; // Subtract indicators column
          adjustedWidth = otherColumnsCount > 0
            ? `${(35 / otherColumnsCount).toFixed(2)}%`
            : '35%';
        }
      }
      // Original equal width logic for when there's no indicators column
      else if (useEqualWidths) {
        // Reserve 25% for static column, distribute remaining 75% equally
        adjustedWidth = `${(75 / dynamicColumnsCount).toFixed(2)}%`;
      }
      // Original logic for more than 3 columns
      else if (items.length <= 2) {
        adjustedWidth = `${(75 / Math.max(items.length, 1)).toFixed(2)}%`;
      } else if (isDataId10 && totalColumns <= 5) {
        adjustedWidth = `${(100 / totalColumns).toFixed(2)}%`;
      } else {
        adjustedWidth = `${(93 / items.length).toFixed(2)}%`;
      }

      return {
        id: index + 2, // Start IDs after staticColumns
        field: item.binding,
        displayName: item.name,
        header: item.name,

        //  code ise visible = false
        isVisible:
          !isCode && (!isIndicator || (dataId !== 11 && dataId !== 12)),

        // Apply width to all columns including indicators when using equal widths
        width: (useEqualWidths || !isIndicator) ? adjustedWidth : "",
        align: isIndicator
          ? 'center'
          : isConsResearch
            ? 'center'
            : taListItem.includes(dataId)
              ? 'center'
              : 'right',
        headerAlign: isIndicator
          ? 'center'  // Changed from 'left' to 'center'
          : isConsResearch
            ? 'center'
            : taListItem.includes(dataId)
              ? 'center'
              : 'right',
        sortable: ![
          'constEstimate',
          'earningsRatioPrevYearEnd',
          'earningsRatioPrevYear',
          'deviation',
        ].includes(item.binding),
        clickable: isCode,
        titleWrap: true,
        format:
          item.binding.startsWith('consResearch') ||
            item.binding.endsWith('_g') ||
            item.binding.endsWith('_h')
            ? 'sb'
            : '',
      };
    });

  return [...staticColumns, ...dynamicColumns];
};

const transformData = (items, columns) => {
  return items.map(item => {
    let combinedFields = lodash.chain(item.fields).keyBy('Id').mapValues('Value').value();



    // combinedFields["consResearch"] = 3;


    const rowData = {};
    columns.forEach(column => {
      let value = Object.prototype.hasOwnProperty.call(item, column.field) ? item[column.field] : combinedFields[column.field] || null;
      rowData[column.field] = value === "NaN" ? '-' : value;
    });
    rowData['entityId'] = item.entityId;
    return rowData;
  });


};

//#endregion

export default function Standouts() {
  
  const dashboardServiceApi = new DashboardServiceApi(new Configuration({ basePath: process.env.REACT_APP_SMARTSCREEN_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_SMARTSCREEN_API_BASE_PATH));
  const SmartQueryApi = new QueryServiceApi(new Configuration({ basePath: process.env.REACT_APP_SMARTSCREEN_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_SMARTSCREEN_API_BASE_PATH));
  const actionHubIndexApi = new IndexServiceApi(new IndexServiceApiConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
  const toast = useRef(null);
  const { t, i18n } = useTranslation();
  const token = useSelector((state) => state.auth?.token);
  const language = i18n.language;
  const [categoryList, setCategoryList] = useState([]);
  const [categoryListError, setCategoryListError] = useState(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(true); // Add this new state
  const [isGridLoading, setGridLoading] = useState(true);
  const [gridPanelError, setGridPanelError] = useState(false);
  const [indexList, setIndexList] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState();
  const [tableData, setTableData] = useState([]);
  const [selectedCategoryDataId, setSelectedCategoryDataId] = useState(1);
  const [columnsData, setColumnsData] = useState([]);
  const [inflationNoteShow, setInflationNoteShow] = useState(false);

  // Enflasyon muhasebesi uyarısının gösterileceği kategoriler (dataId bazlı, dilden bağımsız):
  // 1: Analist Tavsiyeleri, 3-4-5: Kar Tahminleri (Yıllık/Çeyreklik/Dönemsel),
  // 6: Karı Artanlar - Son 3 Yıl, 8: Satış Tahminleri, 9: Satışı Artanlar - Son 3 Yıl
  const listIdsShowMessage = [1, 3, 4, 5, 6, 8, 9];
  const [sortField, setSortField] = useState('588');
  const [sortOrder, setSortOrder] = useState(-1);

  useEffect(() => {
    constituentsApi();
    populateCategoryList();

  }, []);

  useEffect(() => {
    setInflationNoteShow(false);
    if (selectedCategoryDataId !== undefined && selectedIndex !== undefined && columnsData.length !== 0) {
      fetchData();
    }
  }, [selectedCategoryDataId, selectedIndex, columnsData]);

  //#region API Calls
  const constituentsApi = () => {
    const culture = language;
    dashboardServiceApi.dashboardConstituentsGet(token, culture)
      .then((res) => {
        if (res.data.error && res.data.error !== "") {
          toast.current.show({ 
            severity: 'error', 
            summary: t('serviceError'), 
            detail: t('standouts.errors.constituentsLoadError')
          });
          return;
        }
        setIndexList(res.data.Items);
        setSelectedIndex(res.data.Items[0]);
      })
      .catch((error) => {
        console.error('constituentsApi: ' + error);
        toast.current.show({ 
          severity: 'error', 
          summary: t('serviceError'), 
          detail: t('standouts.errors.constituentsLoadError')
        });
      });
  };

  const populateCategoryList = () => {
    setIsCategoryLoading(true); // Set loading state to true when fetching
    const culture = language;
    dashboardServiceApi.dashboardCategorylistGet(token, culture)
      .then((res) => {
        setTimeout(() => {
          if (res.data.error !== "") {
            setCategoryListError(true);
            setIsCategoryLoading(false);
            toast.current.show({ 
              severity: 'error', 
              summary: t('serviceError'), 
              detail: t('standouts.errors.categoryLoadError')
            });
            return;
          }
          if (res.data.Items && res.data.Items.length > 0) {
            // Sadece development modda dataId 11 ve 13 olan itemlar gösterilsin
            // Sadece production modda dataId 11 ve 13 olanlar gizlensin
            console.log('Standouts data: ', res.data.Items);
            const isProd = false; // process.env.REACT_APP_IS_PROD === 'true';
            // Sadece production modda dataId 11 ve 13 olan sub itemlar gizlensin, parentlar her zaman gözüksün
            // Parent'ın sub itemları arasında dataId 11 veya 13 varsa, parent da gizlensin
            const filteredItems = res.data.Items
              .filter(category => {
                // Sadece production modda gizle
                if (isProd) {
                  return !category.items.some(item => item.dataId === 11 || item.dataId === 13);
                }
                return true;
              })
              .map(category => ({
                ...category,
                items: category.items.filter(item => {
                  if ((item.dataId === 11 || item.dataId === 13) && isProd) {
                    return false;
                  }
                  return true;
                })
              }));
            console.log('Standouts CategoryList: ', filteredItems);
            setCategoryList(filteredItems);
            // İlk görünen itemi bul
            const firstCategory = filteredItems.find(cat => cat.items && cat.items.length > 0);
            if (firstCategory) {
              const firstItem = firstCategory.items[0];
              // Sayfa açılışında da enflasyon uyarısının (dataId bazlı) tetiklenebilmesi için
              // ilk kategori seçili hale getirilir
              setSelectedCategoryDataId(firstItem.dataId);
              selectedColumns(firstItem.grid.columns);
            }
          }
          setIsCategoryLoading(false);
        }, 300);
      })
      .catch((error) => {
        console.error('populateCategoryList: ' + error);
        setTimeout(() => {
          setIsCategoryLoading(false);
          setCategoryListError(true);
          toast.current.show({ 
            severity: 'error', 
            summary: t('serviceError'), 
            detail: t('standouts.errors.categoryLoadError')
          });
        }, 300);
      });
  };

  const fetchData = () => {
    setGridLoading(true);
    const currency = 1;
    const culture = language;

    SmartQueryApi.smartscreenFetchdataGet(token, culture, selectedIndex.entityId, selectedCategoryDataId, currency)
      .then((res) => {
        if (res.data.error !== "") {
          setGridLoading(false);
          setGridPanelError(true);
          setTableData([]);
          toast.current.show({
            severity: 'error',
            summary: t('serviceError'),
            detail: t('standouts.errors.dataLoadError')
          });
          setInflationNoteShow(listIdsShowMessage.includes(selectedCategoryDataId));
          return;
        }
        const data = res.data.Items;
        const transformedData = transformData(data, columnsData);

        setInflationNoteShow(transformedData.length === 0 &&
          listIdsShowMessage.includes(selectedCategoryDataId));


        setTableData(transformedData);
        setGridLoading(false);
      })
      .catch((error) => {
        console.error('fetchData: ', error);
        setGridLoading(false);
        setGridPanelError(true);
        setTableData([]);
        toast.current.show({
          severity: 'error',
          summary: t('serviceError'),
          detail: t('standouts.errors.dataLoadError')
        });
        setInflationNoteShow(listIdsShowMessage.includes(selectedCategoryDataId));
      });
  };

  //#endregion

  //#region Event Handlers
  const onIndexListChange = (e) => {
    let index = lodash.findIndex(indexList, { entityId: e.entityId });
    setSelectedIndex(index !== -1 ? indexList[index] : indexList[0]);
  };

  const selectedCategory = (dataId) => {
    console.log('selectedCategory: ', dataId);
    setSelectedCategoryDataId(dataId);
  };

  const selectedColumns = (columnsData, dataId) => {
    setColumnsData(transformColumns(columnsData, dataId));
    if (dataId === 7) {
      const hbkCol = columnsData.find(
        c => c.binding === '401' ||
          c.name === 'HBK - Yıllık Büyüme (1Y)'
      );
      if (hbkCol) {
        setSortField("401");
        setSortOrder(-1);             // DESC
      }
    } else if (dataId === 11) {
      // Teknik Analiz Raporu (Günlük) - sort by ta_g
      setSortField('ta_g');
      setSortOrder(1);                // ASC
    } else if (dataId === 12) {
      // Teknik Analiz Raporu (Haftalık) - sort by ta_h
      setSortField('ta_h');
      setSortOrder(1);                // ASC
    } else {
      // diğer kategoriler
      setSortField('588');
      setSortOrder(-1);
    }
  };
  //#endregion

  return (
    <div className='m-t-15' id='Standouts'>
      <div className='row'>
        <LiveTickerBar />
      </div>
      <Toast ref={toast} position='bottom-right' />
      <div className='m-t-15 d-flex flex-row gap-3'>
        <div style={{ width: '22%' }}>
          {isCategoryLoading ? (
            <Card className="category-card d-flex justify-content-center align-items-center">
              <Spinner height={'100px'} width={'100px'} />
            </Card>
          ) : (
            <Categories categories={categoryList} selectedCategory={selectedCategory} selectedColumns={selectedColumns} />
          )}
        </div>
        <div style={{ width: '80%' }}>
          <Row className='m-b-10'>
            <Col md='4'>
              <DropdownPicker listData={indexList} selectedListItem={selectedIndex} onListItemChange={onIndexListChange} icon={true} />
            </Col>
          </Row>
          <Card className='grid-card' style={{ width: '100%' }}>
            {isGridLoading && <Spinner height={'800px'} />}
            {!isGridLoading && (
              <div className='standouts-table'>
                <DataTableComponent columnsProp={columnsData} dataProp={tableData} columnsSelect={false} sortField={sortField} sortOrder={sortOrder} scrollHeight={800} />
              </div>
            )}
          </Card>
          {inflationNoteShow && (
            <div className='inflation-note'>
              <p>{t('standouts.inflationNote', { year: new Date().getFullYear() })}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
